/* eslint-disable */
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from '../../Component/Button/Button';
import Input from '../../Component/Input/Input';
import ModalSkeleton from '../ModalSkeleton';
import classes from './SaveSearchModal.module.css';

export default function SaveSearchModal({
  show = false,
  setShow = () => {},
  onClick = () => {},
  loading = false,
  t
}) {
  const [title, setTitle] = useState('');

  return (
    <ModalSkeleton
      width={'500px'}
      show={show}
      setShow={setShow}
      modalClass={classes.body}
      showCloseIcon={true}>
      <Row className={classes.gap}>
        <Col md={12}>
          <h6 className="mb-3">{t('saveSearchModal.title')}</h6>
          <Input
            value={title}
            setValue={setTitle}
            placeholder={t('saveSearchModal.placeholder')}
            className="mb-3"
          />
          <div className="d-flex justify-content-end gap-3">
            <Button
              label={t('saveSearchModal.cancel')}
              onClick={() => setShow(false)}
              disabled={loading}
              variant="secondary"
            />
            <Button
              label={loading ? t('saveSearchModal.submitting') : t('saveSearchModal.submit')}
              onClick={() => onClick(title)}
              disabled={loading || !title}
            />
          </div>
        </Col>
      </Row>
    </ModalSkeleton>
  );
}
